import { Edge } from "../backend/types/edge.ts"

export const getEdgeId = (edge: Edge) => edge.SenderID + '-' + edge.ReceiverID
